// // import React, { useEffect, useMemo, useState } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { message } from 'antd';
// // import { GlassCard, GlassButton, GlassModal } from '../../glass';
// // import { useDashboardCalculationMutation, useLincfolioScoreMutation } from '../../slices/zerodhaApiSlice';
// // import { setCalculations, setScore } from '../../slices/dashboardSlice';
// // import { useNavigate } from 'react-router-dom';
// // import panther from '../../images/panther.png';

// // const MONTHLY_TARGET = 50000; // same goal number used for "Goal Crusher"
// // const RANKS = [
// //   { name: 'Rookie', min: 0 },
// //   { name: 'Novice', min: 25 },
// //   { name: 'Skilled', min: 45 },
// //   { name: 'Advanced', min: 65 },
// //   { name: 'Elite', min: 85 },
// // ];

// // const Svg = ({ children, size = 16 }) => (
// //   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
// // );
// // const Star = ({ size }) => <Svg size={size}><path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.8 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z" /></Svg>;
// // const Lock = ({ size }) => <Svg size={size}><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></Svg>;
// // const Doc = ({ size }) => <Svg size={size}><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /></Svg>;
// // const Share = ({ size }) => <Svg size={size}><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="M8.2 10.8l7.6-4.6M8.2 13.2l7.6 4.6" /></Svg>;
// // const Bank = ({ size }) => <Svg size={size}><path d="M3 10l9-6 9 6M5 10v8M9 10v8M15 10v8M19 10v8M3 20h18" /></Svg>;

// // export default function ProfileRank() {
// //   const dispatch = useDispatch();
// //   const { date } = useSelector((s) => s.date);
// //   const { dashboard, score } = useSelector((s) => s.dashboard);
// //   const { dailyjournal } = useSelector((s) => s.dailyjournal);
// //   const [calc] = useDashboardCalculationMutation();
// //   const [getScore] = useLincfolioScoreMutation();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     if (!date?.startDate || !date?.endDate) return;
// //     const range = { startDate: date.startDate, endDate: date.endDate };
// //     calc(range).unwrap().then((r) => dispatch(setCalculations({ ...r }))).catch(() => {});
// //     getScore(range).unwrap().then((r) => dispatch(setScore({ ...r }))).catch(() => {});
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [date]);

// //   // ---- numbers (same sources as the Dashboard) ----
// //   // Each part (win, avg win/loss, profit factor) is out of 300, so the sum is out of 900.
// //   // Dividing by 9 gives the 0-100 score used by the ring and the rank ladder.
// //   const total = score
// //     ? Math.min(100, Math.round(((score.lincwinScore || 0) + (score.lincavgwinlossScore || 0) + (score.lincprofitfactorScore || 0)) / 9))
// //     : 0;
// //   const idx = RANKS.reduce((acc, r, i) => (total >= r.min ? i : acc), 0);
// //   const cur = RANKS[idx];
// //   const next = RANKS[idx + 1];
// //   const pct = next ? Math.round(((total - cur.min) / (next.min - cur.min)) * 100) : 100;

// //   const days = useMemo(
// //     () => [...(dailyjournal?.results || [])]
// //       .map((d) => ({ date: d._id, pnl: (Number(d.totalProfit) || 0) - (Number(d.totalLoss) || 0), trades: Number(d.totalTrades) || 0 }))
// //       .sort((a, b) => String(a.date).localeCompare(String(b.date))),
// //     [dailyjournal],
// //   );
// //   const trades = days.reduce((n, d) => n + d.trades, 0);
// //   const pnl = Number(dashboard?.netrealisedpnl) || 0;
// //   const winPct = Number(dashboard?.winpercent) || 0;
// //   const rr = Number(dashboard?.avgwinloss) || 0;
// //   let run = 0; let best = 0;
// //   days.forEach((d) => { run = d.pnl > 0 ? run + 1 : 0; best = Math.max(best, run); });

// //   const inr = (n) => `₹${Number(n).toLocaleString('en-IN')}`;
// //   const achievements = [
// //     {
// //       name: 'First Trade', hint: 'Log your first trade', ok: trades >= 1,
// //       cur: trades, target: 1, progress: `${trades} / 1 trades`,
// //       done: "It's your first trade! You've logged your first trade on Lincfolio. Every great trader starts with one.",
// //       todo: 'Log your first trade to unlock this.',
// //     },
// //     {
// //       name: '7-Day Streak', hint: '7 profitable days in a row', ok: best >= 7,
// //       cur: best, target: 7, progress: `Best streak: ${best} / 7 days`,
// //       done: 'Seven profitable days in a row. Your consistency is paying off.',
// //       todo: 'Finish 7 profitable trading days in a row to unlock this.',
// //     },
// //     {
// //       name: 'Disciplined', hint: 'Log 20 trades', ok: trades >= 20,
// //       cur: trades, target: 20, progress: `${trades} / 20 trades`,
// //       done: "You've logged 20 trades. Journaling every trade builds discipline.",
// //       todo: 'Log 20 trades to unlock this.',
// //     },
// //     {
// //       name: 'Sharp Shooter', hint: '70%+ wins over 10 trades', ok: trades >= 10 && winPct >= 70,
// //       cur: Math.min(winPct, 70), target: 70, progress: `${winPct.toFixed(0)}% win rate over ${trades} trades (needs 70% over 10+)`,
// //       done: 'A win rate of 70% or more over 10+ trades. Sharp aim!',
// //       todo: 'Reach a 70% win rate over at least 10 trades to unlock this.',
// //     },
// //     {
// //       name: 'Risk Manager', hint: 'Avg win/loss above 2.0', ok: rr >= 2,
// //       cur: Math.min(rr, 2), target: 2, progress: `Avg win/loss: ${rr.toFixed(2)} / 2.00`,
// //       done: 'Your average win is more than twice your average loss. Great risk control.',
// //       todo: 'Get your average win/loss ratio above 2.0 to unlock this.',
// //     },
// //     {
// //       name: 'Goal Crusher', hint: 'Hit your monthly goal', ok: pnl >= MONTHLY_TARGET,
// //       cur: Math.max(0, Math.min(pnl, MONTHLY_TARGET)), target: MONTHLY_TARGET, progress: `${inr(pnl)} / ${inr(MONTHLY_TARGET)}`,
// //       done: 'You hit your monthly profit goal. Crushed it!',
// //       todo: `Reach ${inr(MONTHLY_TARGET)} net P&L to unlock this.`,
// //     },
// //     {
// //       name: 'Century Club', hint: 'Log 100 trades', ok: trades >= 100,
// //       cur: trades, target: 100, progress: `${trades} / 100 trades`,
// //       done: "You've logged 100 trades. Welcome to the Century Club!",
// //       todo: 'Log 100 trades to unlock this.',
// //     },
// //   ];
// //   const unlocked = achievements.filter((a) => a.ok).length;
// //   const [selected, setSelected] = useState(null); // achievement shown in the popup

// //   const share = async () => {
// //     const text = `I'm a ${cur.name} Trader on Lincfolio — score ${total}/100.`;
// //     try { await navigator.clipboard.writeText(text); message.success('Copied to clipboard'); } catch { message.info(text); }
// //   };

// //   return (
// //     <div className="glass-scope">
// //       <div className="gd-head">
// //         <h1>Profile</h1>
// //         <GlassButton onClick={share}><Share size={14} /> Share</GlassButton>
// //       </div>

// //       <div className="pr-grid">
// //         <div className="gd-col">
// //           <GlassCard className="pr-rank">
// //             <div
// //               style={{
// //                 width: 110, height: 110, borderRadius: '50%',
// //                 display: 'flex', alignItems: 'center', justifyContent: 'center',
// //                 background: 'radial-gradient(circle, rgba(203,158,83,.22), rgba(203,158,83,.06))',
// //                 border: '1px solid rgba(203,158,83,.5)',
// //                 boxShadow: '0 0 24px rgba(203,158,83,.35)',
// //               }}
// //             >
// //               <img src={panther} alt="Lincfolio mascot" style={{ width: '86%', height: '86%', objectFit: 'contain' }} />
// //             </div>
// //             <div className="pr-rank__name"><Star size={14} /> {cur.name} Trader</div>
// //             <div className="glass-muted">Lincfolio Score <span className="font-michroma">{total}</span> / 100</div>
// //             <div className="glass-progress__track pr-rank__bar"><div className="glass-progress__bar" style={{ width: `${pct}%` }} /></div>
// //             <div className="glass-muted">{next ? `${next.min - total} pts to ${next.name}` : 'Top rank reached'}</div>
// //           </GlassCard>

// //           <GlassCard title="Rank ladder">
// //             <div className="pr-ladder">
// //               {RANKS.map((r, i) => (
// //                 <div key={r.name} className={`pr-ladder__row ${i === idx ? 'is-active' : i > idx ? 'is-locked' : ''}`}>
// //                   <span className="pr-ladder__dot">{i === idx ? <Star size={13} /> : <span className="pr-ladder__pip" />}</span>
// //                   <span className="pr-ladder__name">{r.name}</span>
// //                   <span className="pr-ladder__min">{r.min}+</span>
// //                 </div>
// //               ))}
// //             </div>
// //           </GlassCard>

// //           <GlassCard>
// //             <div className="gd-cardhead"><h3 className="glass-title"><Bank size={14} /> Broker</h3></div>
// //             <p className="glass-muted" style={{ margin: '0 0 12px' }}>Connect your broker to auto-import trades into your journal.</p>
// //             <GlassButton variant="primary" block onClick={() => document.getElementById('account-settings')?.scrollIntoView({ behavior: 'smooth' })}>
// //               Connect broker
// //             </GlassButton>
// //           </GlassCard>
// //         </div>

// //         <GlassCard>
// //           <div className="gd-cardhead">
// //             <h3 className="glass-title">Achievements</h3>
// //             <button
// //               type="button"
// //               onClick={() => navigate('/achievements')}
// //               style={{ background: 'none', border: 0, color: 'var(--g-gold)', fontSize: 12, cursor: 'pointer' }}
// //             >
// //               {unlocked}/{achievements.length} · View all →
// //             </button>
// //           </div>
// //           <div className="pr-ach">
// //             {achievements.map((a) => (
// //               <div
// //                 key={a.name}
// //                 role="button"
// //                 tabIndex={0}
// //                 className={`pr-ach__tile ${a.ok ? 'is-on' : ''}`}
// //                 style={{ cursor: 'pointer' }}
// //                 onClick={() => setSelected(a)}
// //                 onKeyDown={(e) => {
// //                   if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelected(a); }
// //                 }}
// //               >
// //                 {a.ok ? <Doc size={16} /> : <Lock size={16} />}
// //                 <b>{a.name}</b>
// //                 <small>{a.hint}</small>
// //               </div>
// //             ))}
// //           </div>
// //         </GlassCard>
// //       </div>

// //       <GlassModal
// //         open={!!selected}
// //         onClose={() => setSelected(null)}
// //         title={selected?.name}
// //         width={380}
// //         footer={<GlassButton onClick={() => setSelected(null)}>Close</GlassButton>}
// //       >
// //         {selected && (
// //           <div style={{ display: 'grid', gap: 12, textAlign: 'center', justifyItems: 'center' }}>
// //             <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)' }}>
// //               {selected.ok ? <Doc size={34} /> : <Lock size={34} />}
// //             </div>
// //             <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)', fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase' }}>
// //               {selected.ok ? 'Unlocked' : 'Locked'}
// //             </div>
// //             <p className="glass-muted" style={{ margin: 0, lineHeight: 1.5 }}>
// //               {selected.ok ? selected.done : selected.todo}
// //             </p>
// //             <div style={{ width: '100%' }}>
// //               <div className="glass-progress__track">
// //                 <div className="glass-progress__bar" style={{ width: `${Math.min(100, Math.round((selected.cur / selected.target) * 100))}%` }} />
// //               </div>
// //               <div className="glass-muted" style={{ marginTop: 6, fontSize: 12 }}>{selected.progress}</div>
// //             </div>
// //           </div>
// //         )}
// //       </GlassModal>
// //     </div>
// //   );
// // }



// import React, { useEffect, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { message } from 'antd';
// import { GlassCard, GlassButton, GlassModal } from '../../glass';
// import { useDashboardCalculationMutation, useLincfolioScoreMutation } from '../../slices/zerodhaApiSlice';
// import { setCalculations, setScore } from '../../slices/dashboardSlice';
// import { useNavigate } from 'react-router-dom';
// import panther from '../../images/panther.png';
// import AchievementModal from '../Achievements/AchievementModal';

// const MONTHLY_TARGET = 50000; // same goal number used for "Goal Crusher"
// const RANKS = [
//   { name: 'Rookie', min: 0 },
//   { name: 'Novice', min: 25 },
//   { name: 'Skilled', min: 45 },
//   { name: 'Advanced', min: 65 },
//   { name: 'Elite', min: 85 },
// ];

// const Svg = ({ children, size = 16 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
// );
// const Star = ({ size }) => <Svg size={size}><path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.8 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z" /></Svg>;
// const Lock = ({ size }) => <Svg size={size}><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></Svg>;
// const Doc = ({ size }) => <Svg size={size}><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /></Svg>;
// const Share = ({ size }) => <Svg size={size}><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="M8.2 10.8l7.6-4.6M8.2 13.2l7.6 4.6" /></Svg>;
// const Bank = ({ size }) => <Svg size={size}><path d="M3 10l9-6 9 6M5 10v8M9 10v8M15 10v8M19 10v8M3 20h18" /></Svg>;

// export default function ProfileRank() {
//   const dispatch = useDispatch();
//   const { date } = useSelector((s) => s.date);
//   const { dashboard, score } = useSelector((s) => s.dashboard);
//   const { dailyjournal } = useSelector((s) => s.dailyjournal);
//   const [calc] = useDashboardCalculationMutation();
//   const [getScore] = useLincfolioScoreMutation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!date?.startDate || !date?.endDate) return;
//     const range = { startDate: date.startDate, endDate: date.endDate };
//     calc(range).unwrap().then((r) => dispatch(setCalculations({ ...r }))).catch(() => {});
//     getScore(range).unwrap().then((r) => dispatch(setScore({ ...r }))).catch(() => {});
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [date]);

//   // ---- numbers (same sources as the Dashboard) ----
//   // Each part (win, avg win/loss, profit factor) is out of 300, so the sum is out of 900.
//   // Dividing by 9 gives the 0-100 score used by the ring and the rank ladder.
//   const total = score
//     ? Math.min(100, Math.round(((score.lincwinScore || 0) + (score.lincavgwinlossScore || 0) + (score.lincprofitfactorScore || 0)) / 9))
//     : 0;
//   const idx = RANKS.reduce((acc, r, i) => (total >= r.min ? i : acc), 0);
//   const cur = RANKS[idx];
//   const next = RANKS[idx + 1];
//   const pct = next ? Math.round(((total - cur.min) / (next.min - cur.min)) * 100) : 100;

//   const days = useMemo(
//     () => [...(dailyjournal?.results || [])]
//       .map((d) => ({ date: d._id, pnl: (Number(d.totalProfit) || 0) - (Number(d.totalLoss) || 0), trades: Number(d.totalTrades) || 0 }))
//       .sort((a, b) => String(a.date).localeCompare(String(b.date))),
//     [dailyjournal],
//   );
//   const trades = days.reduce((n, d) => n + d.trades, 0);
//   const pnl = Number(dashboard?.netrealisedpnl) || 0;
//   const winPct = Number(dashboard?.winpercent) || 0;
//   const rr = Number(dashboard?.avgwinloss) || 0;
//   let run = 0; let best = 0;
//   days.forEach((d) => { run = d.pnl > 0 ? run + 1 : 0; best = Math.max(best, run); });

//   const inr = (n) => `₹${Number(n).toLocaleString('en-IN')}`;
//   const achievements = [
//     {
//       name: 'First Trade', hint: 'Log your first trade', ok: trades >= 1,
//       cur: trades, target: 1, progress: `${trades} / 1 trades`,
//       done: "It's your first trade! You've logged your first trade on Lincfolio. Every great trader starts with one.",
//       todo: 'Log your first trade to unlock this.',
//     },
//     {
//       name: '7-Day Streak', hint: '7 profitable days in a row', ok: best >= 7,
//       cur: best, target: 7, progress: `Best streak: ${best} / 7 days`,
//       done: 'Seven profitable days in a row. Your consistency is paying off.',
//       todo: 'Finish 7 profitable trading days in a row to unlock this.',
//     },
//     {
//       name: 'Disciplined', hint: 'Log 20 trades', ok: trades >= 20,
//       cur: trades, target: 20, progress: `${trades} / 20 trades`,
//       done: "You've logged 20 trades. Journaling every trade builds discipline.",
//       todo: 'Log 20 trades to unlock this.',
//     },
//     {
//       name: 'Sharp Shooter', hint: '70%+ wins over 10 trades', ok: trades >= 10 && winPct >= 70,
//       cur: Math.min(winPct, 70), target: 70, progress: `${winPct.toFixed(0)}% win rate over ${trades} trades (needs 70% over 10+)`,
//       done: 'A win rate of 70% or more over 10+ trades. Sharp aim!',
//       todo: 'Reach a 70% win rate over at least 10 trades to unlock this.',
//     },
//     {
//       name: 'Risk Manager', hint: 'Avg win/loss above 2.0', ok: rr >= 2,
//       cur: Math.min(rr, 2), target: 2, progress: `Avg win/loss: ${rr.toFixed(2)} / 2.00`,
//       done: 'Your average win is more than twice your average loss. Great risk control.',
//       todo: 'Get your average win/loss ratio above 2.0 to unlock this.',
//     },
//     {
//       name: 'Goal Crusher', hint: 'Hit your monthly goal', ok: pnl >= MONTHLY_TARGET,
//       cur: Math.max(0, Math.min(pnl, MONTHLY_TARGET)), target: MONTHLY_TARGET, progress: `${inr(pnl)} / ${inr(MONTHLY_TARGET)}`,
//       done: 'You hit your monthly profit goal. Crushed it!',
//       todo: `Reach ${inr(MONTHLY_TARGET)} net P&L to unlock this.`,
//     },
//     {
//       name: 'Century Club', hint: 'Log 100 trades', ok: trades >= 100,
//       cur: trades, target: 100, progress: `${trades} / 100 trades`,
//       done: "You've logged 100 trades. Welcome to the Century Club!",
//       todo: 'Log 100 trades to unlock this.',
//     },
//   ];
//   const unlocked = achievements.filter((a) => a.ok).length;
//   const [selected, setSelected] = useState(null); // achievement shown in the popup

//   const share = async () => {
//     const text = `I'm a ${cur.name} Trader on Lincfolio — score ${total}/100.`;
//     try { await navigator.clipboard.writeText(text); message.success('Copied to clipboard'); } catch { message.info(text); }
//   };

//   return (
//     <div className="glass-scope">
//       <div className="gd-head">
//         <h1>Profile</h1>
//         <GlassButton onClick={share}><Share size={14} /> Share</GlassButton>
//       </div>

//       <div className="pr-grid">
//         <div className="gd-col">
//           <GlassCard className="pr-rank">
//             <div
//               style={{
//                 width: 110, height: 110, borderRadius: '50%',
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 background: 'radial-gradient(circle, rgba(203,158,83,.22), rgba(203,158,83,.06))',
//                 border: '1px solid rgba(203,158,83,.5)',
//                 boxShadow: '0 0 24px rgba(203,158,83,.35)',
//               }}
//             >
//               <img src={panther} alt="Lincfolio mascot" style={{ width: '86%', height: '86%', objectFit: 'contain' }} />
//             </div>
//             <div className="pr-rank__name"><Star size={14} /> {cur.name} Trader</div>
//             <div className="glass-muted">Lincfolio Score <span className="font-michroma">{total}</span> / 100</div>
//             <div className="glass-progress__track pr-rank__bar"><div className="glass-progress__bar" style={{ width: `${pct}%` }} /></div>
//             <div className="glass-muted">{next ? `${next.min - total} pts to ${next.name}` : 'Top rank reached'}</div>
//           </GlassCard>

//           <GlassCard title="Rank ladder">
//             <div className="pr-ladder">
//               {RANKS.map((r, i) => (
//                 <div key={r.name} className={`pr-ladder__row ${i === idx ? 'is-active' : i > idx ? 'is-locked' : ''}`}>
//                   <span className="pr-ladder__dot">{i === idx ? <Star size={13} /> : <span className="pr-ladder__pip" />}</span>
//                   <span className="pr-ladder__name">{r.name}</span>
//                   <span className="pr-ladder__min">{r.min}+</span>
//                 </div>
//               ))}
//             </div>
//           </GlassCard>

//           <GlassCard>
//             <div className="gd-cardhead"><h3 className="glass-title"><Bank size={14} /> Broker</h3></div>
//             <p className="glass-muted" style={{ margin: '0 0 12px' }}>Connect your broker to auto-import trades into your journal.</p>
//             <GlassButton variant="primary" block onClick={() => document.getElementById('account-settings')?.scrollIntoView({ behavior: 'smooth' })}>
//               Connect broker
//             </GlassButton>
//           </GlassCard>
//         </div>

//         <GlassCard>
//           <div className="gd-cardhead">
//             <h3 className="glass-title">Achievements</h3>
//             <button
//               type="button"
//               onClick={() => navigate('/achievements')}
//               style={{ background: 'none', border: 0, color: 'var(--g-gold)', fontSize: 12, cursor: 'pointer' }}
//             >
//               {unlocked}/{achievements.length} · View all →
//             </button>
//           </div>
//           <div className="pr-ach">
//             {achievements.map((a) => (
//               <div
//                 key={a.name}
//                 role="button"
//                 tabIndex={0}
//                 className={`pr-ach__tile ${a.ok ? 'is-on' : ''}`}
//                 style={{ cursor: 'pointer' }}
//                 onClick={() => setSelected(a)}
//                 onKeyDown={(e) => {
//                   if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelected(a); }
//                 }}
//               >
//                 {a.ok ? <Doc size={16} /> : <Lock size={16} />}
//                 <b>{a.name}</b>
//                 <small>{a.hint}</small>
//               </div>
//             ))}
//           </div>
//         </GlassCard>
//       </div>

//       {/* unlocked -> shareable achievement card */}
//       <AchievementModal
//         achievement={selected?.ok ? { title: selected.name, description: selected.done } : null}
//         onClose={() => setSelected(null)}
//       />

//       {/* locked -> progress popup */}
//       <GlassModal
//         open={!!selected && !selected.ok}
//         onClose={() => setSelected(null)}
//         title={selected?.name}
//         width={380}
//         footer={<GlassButton onClick={() => setSelected(null)}>Close</GlassButton>}
//       >
//         {selected && (
//           <div style={{ display: 'grid', gap: 12, textAlign: 'center', justifyItems: 'center' }}>
//             <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)' }}>
//               {selected.ok ? <Doc size={34} /> : <Lock size={34} />}
//             </div>
//             <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)', fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase' }}>
//               {selected.ok ? 'Unlocked' : 'Locked'}
//             </div>
//             <p className="glass-muted" style={{ margin: 0, lineHeight: 1.5 }}>
//               {selected.ok ? selected.done : selected.todo}
//             </p>
//             <div style={{ width: '100%' }}>
//               <div className="glass-progress__track">
//                 <div className="glass-progress__bar" style={{ width: `${Math.min(100, Math.round((selected.cur / selected.target) * 100))}%` }} />
//               </div>
//               <div className="glass-muted" style={{ marginTop: 6, fontSize: 12 }}>{selected.progress}</div>
//             </div>
//           </div>
//         )}
//       </GlassModal>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { GlassCard, GlassButton, GlassModal } from '../../glass';
import { useDashboardCalculationMutation, useLincfolioScoreMutation } from '../../slices/zerodhaApiSlice';
import { setCalculations, setScore } from '../../slices/dashboardSlice';
import { useNavigate } from 'react-router-dom';
import panther from '../../images/panther.png';
import AchievementModal from '../Achievements/AchievementModal';
import { useCheckAchievementQuery } from '../../slices/achievementApiSlice';

const MONTHLY_TARGET = 50000; // same goal number used for "Goal Crusher"
const RANKS = [
  { name: 'Rookie', min: 0 },
  { name: 'Novice', min: 25 },
  { name: 'Skilled', min: 45 },
  { name: 'Advanced', min: 65 },
  { name: 'Elite', min: 85 },
];

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);
const Star = ({ size }) => <Svg size={size}><path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.8 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z" /></Svg>;
const Lock = ({ size }) => <Svg size={size}><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></Svg>;
const Doc = ({ size }) => <Svg size={size}><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /></Svg>;
const Share = ({ size }) => <Svg size={size}><circle cx="18" cy="5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="19" r="2.5" /><path d="M8.2 10.8l7.6-4.6M8.2 13.2l7.6 4.6" /></Svg>;
const Bank = ({ size }) => <Svg size={size}><path d="M3 10l9-6 9 6M5 10v8M9 10v8M15 10v8M19 10v8M3 20h18" /></Svg>;

export default function ProfileRank() {
  const dispatch = useDispatch();
  const { date } = useSelector((s) => s.date);
  const { dashboard, score } = useSelector((s) => s.dashboard);
  const { dailyjournal } = useSelector((s) => s.dailyjournal);
  const [calc] = useDashboardCalculationMutation();
  const [getScore] = useLincfolioScoreMutation();
  const navigate = useNavigate();

  // asks the backend to check the user's trades and save newly unlocked achievements
  useCheckAchievementQuery(undefined, { refetchOnMountOrArgChange: true });

  useEffect(() => {
    if (!date?.startDate || !date?.endDate) return;
    const range = { startDate: date.startDate, endDate: date.endDate };
    calc(range).unwrap().then((r) => dispatch(setCalculations({ ...r }))).catch(() => {});
    getScore(range).unwrap().then((r) => dispatch(setScore({ ...r }))).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  // ---- numbers (same sources as the Dashboard) ----
  // Each part (win, avg win/loss, profit factor) is out of 300, so the sum is out of 900.
  // Dividing by 9 gives the 0-100 score used by the ring and the rank ladder.
  const total = score
    ? Math.min(100, Math.round(((score.lincwinScore || 0) + (score.lincavgwinlossScore || 0) + (score.lincprofitfactorScore || 0)) / 9))
    : 0;
  const idx = RANKS.reduce((acc, r, i) => (total >= r.min ? i : acc), 0);
  const cur = RANKS[idx];
  const next = RANKS[idx + 1];
  const pct = next ? Math.round(((total - cur.min) / (next.min - cur.min)) * 100) : 100;

  const days = useMemo(
    () => [...(dailyjournal?.results || [])]
      .map((d) => ({ date: d._id, pnl: (Number(d.totalProfit) || 0) - (Number(d.totalLoss) || 0), trades: Number(d.totalTrades) || 0 }))
      .sort((a, b) => String(a.date).localeCompare(String(b.date))),
    [dailyjournal],
  );
  const trades = days.reduce((n, d) => n + d.trades, 0);
  const pnl = Number(dashboard?.netrealisedpnl) || 0;
  const winPct = Number(dashboard?.winpercent) || 0;
  const rr = Number(dashboard?.avgwinloss) || 0;
  let run = 0; let best = 0;
  days.forEach((d) => { run = d.pnl > 0 ? run + 1 : 0; best = Math.max(best, run); });

  const inr = (n) => `₹${Number(n).toLocaleString('en-IN')}`;
  const achievements = [
    {
      name: 'First Trade', hint: 'Log your first trade', ok: trades >= 1,
      cur: trades, target: 1, progress: `${trades} / 1 trades`,
      done: "It's your first trade! You've logged your first trade on Lincfolio. Every great trader starts with one.",
      todo: 'Log your first trade to unlock this.',
    },
    {
      name: '7-Day Streak', hint: '7 profitable days in a row', ok: best >= 7,
      cur: best, target: 7, progress: `Best streak: ${best} / 7 days`,
      done: 'Seven profitable days in a row. Your consistency is paying off.',
      todo: 'Finish 7 profitable trading days in a row to unlock this.',
    },
    {
      name: 'Disciplined', hint: 'Log 20 trades', ok: trades >= 20,
      cur: trades, target: 20, progress: `${trades} / 20 trades`,
      done: "You've logged 20 trades. Journaling every trade builds discipline.",
      todo: 'Log 20 trades to unlock this.',
    },
    {
      name: 'Sharp Shooter', hint: '70%+ wins over 10 trades', ok: trades >= 10 && winPct >= 70,
      cur: Math.min(winPct, 70), target: 70, progress: `${winPct.toFixed(0)}% win rate over ${trades} trades (needs 70% over 10+)`,
      done: 'A win rate of 70% or more over 10+ trades. Sharp aim!',
      todo: 'Reach a 70% win rate over at least 10 trades to unlock this.',
    },
    {
      name: 'Risk Manager', hint: 'Avg win/loss above 2.0', ok: rr >= 2,
      cur: Math.min(rr, 2), target: 2, progress: `Avg win/loss: ${rr.toFixed(2)} / 2.00`,
      done: 'Your average win is more than twice your average loss. Great risk control.',
      todo: 'Get your average win/loss ratio above 2.0 to unlock this.',
    },
    {
      name: 'Goal Crusher', hint: 'Hit your monthly goal', ok: pnl >= MONTHLY_TARGET,
      cur: Math.max(0, Math.min(pnl, MONTHLY_TARGET)), target: MONTHLY_TARGET, progress: `${inr(pnl)} / ${inr(MONTHLY_TARGET)}`,
      done: 'You hit your monthly profit goal. Crushed it!',
      todo: `Reach ${inr(MONTHLY_TARGET)} net P&L to unlock this.`,
    },
    {
      name: 'Century Club', hint: 'Log 100 trades', ok: trades >= 100,
      cur: trades, target: 100, progress: `${trades} / 100 trades`,
      done: "You've logged 100 trades. Welcome to the Century Club!",
      todo: 'Log 100 trades to unlock this.',
    },
  ];
  const unlocked = achievements.filter((a) => a.ok).length;
  const [selected, setSelected] = useState(null); // achievement shown in the popup

  const share = async () => {
    const text = `I'm a ${cur.name} Trader on Lincfolio — score ${total}/100.`;
    try { await navigator.clipboard.writeText(text); message.success('Copied to clipboard'); } catch { message.info(text); }
  };

  return (
    <div className="glass-scope">
      <div className="gd-head">
        <h1>Profile</h1>
        <GlassButton onClick={share}><Share size={14} /> Share</GlassButton>
      </div>

      <div className="pr-grid">
        <div className="gd-col">
          <GlassCard className="pr-rank">
            <div
              style={{
                width: 110, height: 110, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'radial-gradient(circle, rgba(203,158,83,.22), rgba(203,158,83,.06))',
                border: '1px solid rgba(203,158,83,.5)',
                boxShadow: '0 0 24px rgba(203,158,83,.35)',
              }}
            >
              <img src={panther} alt="Lincfolio mascot" style={{ width: '86%', height: '86%', objectFit: 'contain' }} />
            </div>
            <div className="pr-rank__name"><Star size={14} /> {cur.name} Trader</div>
            <div className="glass-muted">Lincfolio Score <span className="font-michroma">{total}</span> / 100</div>
            <div className="glass-progress__track pr-rank__bar"><div className="glass-progress__bar" style={{ width: `${pct}%` }} /></div>
            <div className="glass-muted">{next ? `${next.min - total} pts to ${next.name}` : 'Top rank reached'}</div>
          </GlassCard>

          <GlassCard title="Rank ladder">
            <div className="pr-ladder">
              {RANKS.map((r, i) => (
                <div key={r.name} className={`pr-ladder__row ${i === idx ? 'is-active' : i > idx ? 'is-locked' : ''}`}>
                  <span className="pr-ladder__dot">{i === idx ? <Star size={13} /> : <span className="pr-ladder__pip" />}</span>
                  <span className="pr-ladder__name">{r.name}</span>
                  <span className="pr-ladder__min">{r.min}+</span>
                </div>
              ))}
            </div>
          </GlassCard>

          <GlassCard>
            <div className="gd-cardhead"><h3 className="glass-title"><Bank size={14} /> Broker</h3></div>
            <p className="glass-muted" style={{ margin: '0 0 12px' }}>Connect your broker to auto-import trades into your journal.</p>
            <GlassButton variant="primary" block onClick={() => document.getElementById('account-settings')?.scrollIntoView({ behavior: 'smooth' })}>
              Connect broker
            </GlassButton>
          </GlassCard>
        </div>

        <GlassCard>
          <div className="gd-cardhead">
            <h3 className="glass-title">Achievements</h3>
            <button
              type="button"
              onClick={() => navigate('/achievements')}
              style={{ background: 'none', border: 0, color: 'var(--g-gold)', fontSize: 12, cursor: 'pointer' }}
            >
              {unlocked}/{achievements.length} · View all →
            </button>
          </div>
          <div className="pr-ach">
            {achievements.map((a) => (
              <div
                key={a.name}
                role="button"
                tabIndex={0}
                className={`pr-ach__tile ${a.ok ? 'is-on' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => setSelected(a)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelected(a); }
                }}
              >
                {a.ok ? <Doc size={16} /> : <Lock size={16} />}
                <b>{a.name}</b>
                <small>{a.hint}</small>
              </div>
            ))}
          </div>
        </GlassCard>
      </div>

      {/* unlocked -> shareable achievement card */}
      <AchievementModal
        achievement={selected?.ok ? { title: selected.name, description: selected.done } : null}
        onClose={() => setSelected(null)}
      />

      {/* locked -> progress popup */}
      <GlassModal
        open={!!selected && !selected.ok}
        onClose={() => setSelected(null)}
        title={selected?.name}
        width={380}
        footer={<GlassButton onClick={() => setSelected(null)}>Close</GlassButton>}
      >
        {selected && (
          <div style={{ display: 'grid', gap: 12, textAlign: 'center', justifyItems: 'center' }}>
            <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)' }}>
              {selected.ok ? <Doc size={34} /> : <Lock size={34} />}
            </div>
            <div style={{ color: selected.ok ? 'var(--g-gold)' : 'var(--g-muted)', fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase' }}>
              {selected.ok ? 'Unlocked' : 'Locked'}
            </div>
            <p className="glass-muted" style={{ margin: 0, lineHeight: 1.5 }}>
              {selected.ok ? selected.done : selected.todo}
            </p>
            <div style={{ width: '100%' }}>
              <div className="glass-progress__track">
                <div className="glass-progress__bar" style={{ width: `${Math.min(100, Math.round((selected.cur / selected.target) * 100))}%` }} />
              </div>
              <div className="glass-muted" style={{ marginTop: 6, fontSize: 12 }}>{selected.progress}</div>
            </div>
          </div>
        )}
      </GlassModal>
    </div>
  );
}